import React from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm } from 'redux-form/immutable';
import { getTapsFileHref } from 'utils';
import { Link } from 'redux-little-router';
import styles from './PercentDepositsConfirmation.module.scss';
import { compose } from 'redux';
import { connect } from 'react-redux';

const PercentDepositsConfirmation = ({ formProps: { handleSubmit }, onSubmit, pdf }) => {
  return (
    <div className={`${styles.content} boo`}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className={'p-4'}>
          <p>Проверьте правильность введенной информации. Для продолжения нажмите «Отправить»</p>
          <div className={'mb-4'}>
            <h2 className={'mt-4 mb-4'}>Сформированный запрос</h2>
            {!!pdf && (
              <div className={styles.block}>
                <Link className="link link_pdf" href={getTapsFileHref(pdf)} target="_blank">
                  Сообщение об уточнении представленной банком информации о сумме полученного дохода
                </Link>
              </div>
            )}
          </div>
        </div>
      </Form>
    </div>
  );
};

PercentDepositsConfirmation.propTypes = {
  formName: PropTypes.string,
  formProps: PropTypes.object,
  onSubmit: PropTypes.func,
  pdf: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const { formName } = ownProps;

  return {
    ...ownProps,
    form: formName,
  };
};

export default compose(
  connect(mapStateToProps),
  reduxForm({
    propNamespace: 'formProps',
    destroyOnUnmount: false,
  }),
)(PercentDepositsConfirmation);
